import { render } from "./AddSociete.vue?vue&type=template&id=761dd030&ts=true"
import script from "./AddSociete.vue?vue&type=script&lang=ts"
export * from "./AddSociete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__